import RpAlert from "@/components/alerts/RpAlert";

type NoAssetFoundMsgProps = {
  type?: string;
};

function NoAssetFoundMsg({ type }: NoAssetFoundMsgProps) {
  return (
    <div className="w-100">
      <RpAlert severity="info">{`No ${type} found!`}</RpAlert>
    </div>
  );
}

export default NoAssetFoundMsg;
